import { render, staticRenderFns } from "./ResultsItem.vue?vue&type=template&id=1547c71a&"
import script from "./ResultsItem.vue?vue&type=script&lang=js&"
export * from "./ResultsItem.vue?vue&type=script&lang=js&"
import style0 from "./ResultsItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports